import TdlTypeaheadCommon from './tdlTypeaheadCommon';
import { mdiMagnify } from '@mdi/js';

export default {
  mixins: [TdlTypeaheadCommon],
  props: {
    selectedItems: {
      type: Array,
      required: true,
    },
    onlyChips: {
      type: Boolean,
      default: false,
    },
    enabledScroll: {
      type: Boolean,
      default: false,
    },
    onlyRegularCharacters: {
      type: Boolean,
      default: false,
    },
    disabled: Boolean,
    addNewItem: Boolean,
    itemFactory: Function,
    textAttribute: {
      type: String,
      default: 'text',
    },
    idAttribute: {
      type: String,
      default: 'id',
    },
    loading: Boolean,
    itemList: {
      type: Array,
      required: true,
    },
    excludedList: {
      type: Array,
      default: () => [],
    },
    itemListFixed: Boolean,
    softList: {
      type: Boolean,
      default: false,
    },
    softTitle: {
      type: String,
      default: '',
    },
    disableMaxWidth: {
      type: Boolean,
      default: false,
    },
    searchHintMode: String,
    addItemOnKeypress: {
      type: String,
      required: false,
    },
    showArrowDown: {
      type: Boolean,
      default: false,
    },
    forceClose: {
      type: Boolean,
      default: false,
    },
    minChars: {
      type: Number,
      default: 0,
    },
    grouped: {
      type: Boolean,
    },
    emptyValuesMessage: {
      type: String,
    },
  },
  computed: {
    isInteractingWithList() {
      return this.listItemPressed || this.highlighted >= 0;
    },
    itemListVisible() {
      const hasItems = this.itemList.length > 0;
      const addItemOptionVisible = (this.addNewItem && this.query.length > 0) || (this.softList && this.softTitle);
      return this.activeItemList && (hasItems || addItemOptionVisible);
    },
    showSearchHint() {
      if (this.disabled) {
        return false;
      }
      switch (this.searchHintMode) {
        case 'focus':
          return this.focused;
        case 'fixed':
          return true;
        default:
          return false;
      }
    },
  },
  data() {
    return {
      focused: false,
      activeItemList: false,
      highlighted: -1,
      listItemPressed: false,
      listElementRef: undefined,
      listOffsetY: 0,
      mdiMagnify,
    };
  },
  watch: {
    itemList() {
      this.$nextTick(() => {
        this.setListTopLeftHeight();
      });
    },
    itemListVisible(newVal) {
      if (newVal) {
        this.disableScroll(this.enabledScroll);

        this.$nextTick(() => {
          this.setListTopLeftHeight();
        });
      } else {
        this.enableScroll(this.enabledScroll);
      }
    },
    selectedItems(newVal, oldVal) {
      const deleted = newVal.length < oldVal.length;

      if (deleted && !this.forceClose) {
        // this.applyInputFocus();
      }
    },
    disabled(newVal) {
      if (newVal) {
        this.onInputBlur();
      }
    },
    focused(newVal) {
      this.$emit('focused', { focused: newVal, query: this.query });
    },
  },
  mounted() {
    this.listOffsetY = window.pageYOffset;

    this.$nextTick(() => {
      const list = this.$refs.list;

      if (list) {
        this.listElementRef = this.$refs.list.$el;
        document.body.appendChild(this.listElementRef);
      }
    });
  },
  beforeUnmount() {
    if (this.listElementRef) {
      document.body.removeChild(this.listElementRef);
      this.listElementRef = undefined;
    }
    // TODO: Refactor this for Vue3
    // this.$off('item-selected', this.applyInputFocus);
  },
  methods: {
    onInputFocus(e) {
      this.focused = true;
      this.openList();
    },
    onInputBlur(e) {
      this.focused = false;
      if (this.onlyChips) {
        this.inferItem();
      }
      if (!this.isInteractingWithList) {
        this.closeList();
      }
    },
    applyInputFocus() {
      // waits for event propagation and handling before attempting to set focus
      // always check refs.input exists (it might have been deleted by conditionals in client side)
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.$refs.input.$el.blur();
          this.$nextTick(() => {
            if (!this.disabled && this.$refs.input) {
              this.$refs.input.$el.focus();
            }
          });
        }
      });
    },
    openList() {
      if (this.focused) {
        if (!this.activeItemList) {
          this.highlighted = -1;
          this.activeItemList = true;
          this.$emit('list-opened');
        }
      }
    },
    closeList() {
      if (this.activeItemList) {
        this.highlighted = -1;
        this.activeItemList = false;
        this.$emit('list-closed');
      }
    },
    highlightItem(direction) {
      // unsets action onblur of the element highlighted before, only the highlighted
      // element closes the list if loses focus because not moving to another one
      if (this.grouped) {
        // TODO: enable highlight on grouped autocomp.ete
        return;
      }
      const item = this.listElementRef.children;
      if (this.highlighted >= 0 && item && item[this.highlighted]?.children?.length > 1) {
        item[this.highlighted].children[1].onblur = undefined;
      }

      if (direction === 'up') {
        if (this.highlighted === 0 || this.highlighted === -1) {
          this.highlighted = this.listElementRef.childElementCount - 1;
        } else {
          this.highlighted--;
        }
      }

      if (direction === 'down') {
        if (this.highlighted === this.listElementRef.childElementCount - 1) {
          this.highlighted = 0;
        } else {
          this.highlighted++;
        }
      }
      const firstChild = this.listElementRef.children[this.highlighted].children[1];
      if (firstChild) {
        firstChild.onblur = this.closeList;
        firstChild.focus();
      }
    },
    inferItem() {
      if (this.grouped) {
        // TODO: Enable keyboard actiona for grouped input
        return;
      }
      if (!this.loading && this.itemList.length > 0) {
        // choose first if no selection
        const item = this.itemList[0];
        if (item) {
          this.selectItem(item);
        }
      } else if (!this.grouped) {
        this.createItem();
      }
    },
    requestLastItemDeletion() {
      if (this.query.length === 0 && this.selectedItems.length > 0 && !this.itemListVisible) {
        this.$emit('item-removed', this.selectedItems[this.selectedItems.length - 1]);
      }
    },
    handleItemMouseDown() {
      this.listItemPressed = true;
    },
    handleItemMouseUp() {
      this.listItemPressed = false;
      this.$nextTick(() => {
        this.onInputBlur();
      });
    },
    handleTab(evt) {
      if (this.loading) {
        evt.preventDefault();
      } else {
        this.inferItem();
      }
    },
    setListTopLeftHeight() {
      const list = this.listElementRef;
      const input = this.$refs.input.$el;

      const listPosition = input.getBoundingClientRect();
      let offsetY =
        this.checkFixedPositionedParent(input) && this.listOffsetY != window.pageYOffset ? window.pageYOffset : 0;

      list.style.left = (this.itemListFixed ? listPosition.left - input.offsetLeft : listPosition.left) + 'px';

      list.style.top = offsetY + listPosition.top + input.clientHeight + 'px';
      if (!this.disableMaxWidth) {
        list.style['max-width'] = listPosition.width + 'px';
      }

      const listItemHeight = list.childElementCount ? list.children[0].clientHeight : 48;
      let listHeight = this.itemList.length * listItemHeight;
      if (this.grouped) {
        this.itemList.forEach((item) => {
          if (item.values.length) {
            listHeight += item.values.length * listItemHeight;
          } else {
            listHeight += listItemHeight;
          }
        });
      }
      if (input.clientHeight + listPosition.top + listHeight > window.innerHeight - listItemHeight) {
        let listBottom = window.innerHeight - (listPosition.top + input.clientHeight);
        let maxNumberOfItems = 0;

        if (listBottom < listItemHeight * 2) {
          const listTop = listPosition.top > listHeight ? listPosition.top - listHeight : 20;

          list.style.top = offsetY + listTop + 'px';
          maxNumberOfItems = Math.floor((listPosition.top - listTop) / listItemHeight);
        } else {
          maxNumberOfItems = Math.floor(listBottom / listItemHeight);
        }

        list.style.height =
          (this.itemListShow && this.itemListShow < maxNumberOfItems ? this.itemListShow : maxNumberOfItems) *
            listItemHeight +
          'px';
      } else {
        list.style.height =
          this.itemListShow && this.itemListShow < this.itemList.length
            ? this.itemListShow * listItemHeight + 'px'
            : 'auto';
      }
    },
    checkFixedPositionedParent(el) {
      let result = false;

      while (el) {
        if (window.getComputedStyle(el)['position'] === 'fixed') {
          result = true;
          break;
        }

        el = el.offsetParent;
      }

      return result;
    },
    preventScroll(event) {
      // overrides mixin
      if (this.listElementRef && !this.listElementRef.contains(event.target)) {
        event.preventDefault();
      }
    },
    requestFocus() {
      this.applyInputFocus();
    },
    getMoreItems(item) {
      this.$emit('next-page', item);
      this.requestFocus();
    },
  },
};
